angular
  .module("accordionDatiCliente.components", [])
  .component("accordionDatiCliente", {
    templateUrl: "ng/components/accordionDatiCliente/accordionDatiCliente.view.html",
    bindings: {
      //utils
      containerClass: "@",
      riUserG: "<",
      riUserF: "<",
      //this outputs:
      //result as 'true' or 'false'
      //datiCliente as 'riUserG
      onRiUserChanges: "&?",
      onSedeChanges: "&?",
      selectCervedData: "@",
      onCervedUpdate: "&?",
      cervedData: "&?",
      customer: "<",
      showBackButton: "&?",
      successCervedCall: "&?",
      digital: "=",
      onRiUserFChanges: "&?",
      snapshot: '<',
      onCervedUpdateFinish: '&',
      financialModel: '='
    },
    controllerAs: "accordionDatiCliente",
    controller: function ControllerDatiCliente(
      RiUserG,
      $typeDomainService,
      $cervedService,
      $modalService,
      $timeout,
      validationService,
      Stato,
      RiUserF,
      Pf,
      Titolare,
      $scope,
      $rootScope,
      $financialApiService,
      $giuridicVersion
    ) {
      var self = this;

      self.model = {
        loading: {
          sae: false,
          rae: false,
          giuridicForm: false
        },
        disabled: {
          rae: true
        },
        dropdown: {
          customerNatures: [],
          legalStatuses: [],
          sae: [],
          rae: []
        },
        alboProfessionale: {
          nome: "",
          descrizione: ""
        },
        populated: false,
        populatedEmailPec: false,
        populatedAteco: false,
        populatedSae: false,
        populatedRae: false,
        populatedPersonaFisica: false,
        alboSelected: ""
      };

      self.initialIndex = 0;

      self.$onInit = function () {
        /**
         * Instantiate the model
         * 1. it could come from a prepopulated model
         * 2. it could come from an empty model (next or back from wf..)
         */
        self.$giuridicVersion = $giuridicVersion;
        self.model.riUserG = RiUserG.build(self.riUserG);
        self.areMoreAddressesVisible = self.snapshot;

        /** Set the populated flag to true if there's an incoming model */
        if (self.riUserG && self.riUserG.piva) {
          self.model.populated = true;
        }

        if (self.riUserG && self.riUserG.emailPec) {
          self.model.populatedEmailPec = true;
        }

        if (self.riUserG && self.riUserG.ateco) {
          self.model.populatedAteco = true;
        }

        if (self.riUserG && self.riUserG.sae) {
          self.model.populatedSae = true;
        }

        if (self.riUserG && self.riUserG.rae) {
          self.model.populatedRae = true;
        }


        if (self.riUserG.ndg == null && ($giuridicVersion.checkIfInd(self.riUserG.formaGiuridica) || self.riUserG.formaGiuridica === 'PEF') && self.digital) {
          self.titolare = Titolare.build()
          self.model.pf = Pf.build(self.titolare);
          self.model.riUserF = RiUserF.build(self.riUserF);
          if (self.riUserF && (self.riUserF.listaPf.length === 0)) {
            self.model.riUserF.listaPf.push(self.model.pf);
          } else {
            if (self.riUserF.listaPf[0].nome != null && self.riUserF.listaPf[0].cognome != null) {
              self.model.populatedPersonaFisica = true;
            }
          }
          self.enableNameSurnameRow = true;
          self.model.pf.titolare.selected = true;
        }

        if (self.riUserG.cf == null && self.digital) {
          self.model.riUserG.cf = self.model.riUserG.piva;
        }
        self.supportModel = {
          riUserG: jQuery.extend(true, {}, self.riUserG)
        }
        self.fieldChanges();

        self.getAllLegalStatuses();

        self.cervedCallUpdate();

        if (self.model && self.model.riUserG && self.model.riUserG.formaGiuridica) {
          self.getSaeByLegalStatus(self.model.riUserG.formaGiuridica);
        }

        if (self.model && self.model.riUserG && self.model.riUserG.sae) {
          self.getRaeBySae(self.model.riUserG.sae);
        }

        if (self.model.riUserG.formaGiuridica != null) {
          getInfoAlbo(self.model.riUserG.formaGiuridica, self.model.riUserG.ateco, self.model.riUserG.showAlbo);
        }
      };

      self.getAllLegalStatuses = function () {
        self.model.loading.giuridicForm = true;
        self.waitForLegal = true;
        $typeDomainService
          .getAllLegalStatuses()
          .then(function (legalStatuses) {
            self.model.dropdown.legalStatuses = legalStatuses;
            self.waitForLegal = false;
          })
          .finally(function () {
            self.model.loading.giuridicForm = false;
          });
      };

      self.getSaeByLegalStatus = function (legalStatus, fromViewHtml) {
        self.model.loading.sae = true;
        if (fromViewHtml) {
          self.model.riUserG.sae = "";
        }
        self.waitForSaeByLegal = true;
        $typeDomainService
          .getSaeByLegalStatus(legalStatus)
          .then(function (saeList) {
            self.model.dropdown.sae = saeList;
            self.waitForSaeByLegal = false;
          })
          .finally(function () {
            self.model.loading.sae = false;
          });
      };

      self.getRaeBySae = function (sae, fromViewHtml) {
        self.model.loading.rae = true;

        if (fromViewHtml) {
          self.model.riUserG.rae = "";
        }
        self.waitForRaeBySae = true;
        $typeDomainService
          .getRaeBySae(sae)
          .then(function (raeList) {
            self.model.dropdown.rae = raeList;

            //Prevalorizzazione del singolo risultato
            if (raeList && raeList.length == 1) {
              self.model.riUserG.rae = raeList[0].id;
            }

            //Disabilitare se c'è un solo risultato
            if (raeList && raeList.length === 1) {
              self.model.disabled.rae = true;
            } else {
              self.model.disabled.rae = false;
            }
            self.waitForRaeBySae = false;
          })
          .finally(function () {
            self.model.loading.rae = false;
          });
      };

      self.fieldChanges = function (name, value, type) {
        if (type == 'riUserG') {
          if (name === 'sedeLegale' || name === 'sedeConsegna' || name === 'sedeFatturazione') {

            self.otherAddressesComplete = self.model.riUserG.sedeConsegna.isOk();

            if (value && !value.stato.name &&
              (value.stato.value == "086" || value.stato.description == "086")) {
              value.stato = Stato.build();
            }
            if (value && !value.luogoEsteso.nome) {
              if (value.luogoEsteso === "") {
                value.luogoEsteso = {};
              }
              value.luogoEsteso.nome = value.comune;
            }
            self.model.riUserG[name] = value;
          } else if (name === "ateco") {
            self.model.riUserG.ateco = value.id;
            self.model.alboSelected = value;
            self.model.dropdown.alboProfessionale.forEach(function (element) {
              if (element.id == value.id) {
                element.selected = true;
              }
            })
          } else if (name === 'cf') {
            self.model.riUserG.cf = self.model.riUserG.cf && self.model.riUserG.cf.toUpperCase();

          } else if (name === 'dataIscrizioneAlbo') {
            self.model.riUserG.dataIscrizioneAlbo = value;
          } else {
            //update the model and output it
            self.model.riUserG[name] = value;
          }
          //check it for validity
          if (self.model.riUserG.formaGiuridica === 'PEF') {
            var info = self.model.riUserG.isOk(false, false, false, false, true);
          } else if (self.model.riUserG.pIvaAssente) {
            var info = self.model.riUserG.isOk(false, false, false, false, true, false);
          } else {
            var info = self.model.riUserG.isOk(false, false, true);
          }
          //fieldChanges('sedeLegale', model, result)
          self.onRiUserChanges({
            datiCliente: self.model.riUserG,
            result: info,
            formaGiuridica: self.model.riUserG.formaGiuridica
          });

        } else {

          if (self.model.riUserF) {

            if (self.model.riUserF.listaPf[0].nome != null && self.model.riUserF.listaPf[0].cognome != null) {

              if (self.model.riUserF.listaPf[0].cf == null) {
                self.model.riUserF.listaPf[0].cf = self.riUserG.cf;
              }


            }
            $timeout(function () {
              var info = validationService.checkCfWithName(self.model.riUserF.listaPf[0].cf, self.model.riUserF.listaPf[0].cognome, self.model.riUserF.listaPf[0].nome) && $scope.FormDatiSocietari && $scope.FormDatiSocietari.$valid;
              self.errorCodiceFiscale = validationService.checkCfWithName(self.model.riUserF.listaPf[0].cf, self.model.riUserF.listaPf[0].cognome, self.model.riUserF.listaPf[0].nome);

              self.onRiUserFChanges({
                datiPf: self.model.riUserF,
                result: info
              });

            }, 500)

            if (type == 'residenza') {
              self.model.riUserF.listaPf[0].residenza = value;
            }

          }

        }

      };
      /**
       * NSIL
       **/

      self.getUpdatedDataFromNsil = function () {
        if (self.snapshot) {
          return
        }
        self.onCervedUpdate({
          showUpdateFromCerved: true,
          nsil: true
        });

        self.successCervedCall({
          isCervedData: false
        })

        self.model.riUserG.updateFromCerved = false;
        self.customer.metadata.riUserG.updateFromCerved = false;

        if (!self.snapshot) {
          self.toggleFooterZindex('');
        }
        $financialApiService
          .getSearchNsilUserG(self.model.riUserG)
          .then(function (listAppCustomer) {

            if (listAppCustomer.success) {
              self.riUserG = listAppCustomer.appCustomerUser.metadata.riUserG;
              if (self.riUserG.ndg == null && ($giuridicVersion.checkIfInd(self.riUserG.formaGiuridica) || self.riUserG.formaGiuridica === 'PEF') && self.digital) {
                self.enableNameSurnameRow = true;
                self.titolare = Titolare.build()
                self.model.pf = Pf.build(self.titolare);
                self.model.riUserF = RiUserF.build(self.riUserF);
                if (self.riUserF && (self.riUserF.listaPf.length === 0)) {
                  self.model.riUserF.listaPf.push(self.model.pf);
                } else {
                  if (self.riUserF.listaPf[0].nome != null && self.riUserF.listaPf[0].cognome != null) {
                    self.model.populatedPersonaFisica = true;
                  }
                }
                self.model.riUserF.listaPf[0] = Pf.build(self.model.riUserF.listaPf[0]);
                self.model.riUserF.listaPf[0].titolare.selected = true;
                self.model.riUserF.listaPf[0].cf = cervedResponse.appCustomerUser.metadata.riUserG.cf;
              }

              self.cervedData({
                dataFromCerved: self.riUserG
              })

              console.log("RiUserG: ", self.riUserG);
              self.onCervedUpdateFinish({
                value: true
              });
            } else {
              self.onCervedUpdate({
                showUpdateFromCerved: false
              });

            }

          })
          .catch(function () {
            self.onCervedUpdate({
              showUpdateFromCerved: false
            });
            self.successCervedCall({
              isCervedData: false
            })
          })
          .finally(function () {
            self.toggleFooterZindex('back');
          });
      }

      /**
       * Cerved
       **/
      self.getUpdatedDataFromCerved = function () {
        if (self.snapshot) {
          return
        }
        self.onCervedUpdate({
          showUpdateFromCerved: true
        });

        self.successCervedCall({
          isCervedData: false
        })

        if (self.digital) {
          if (!self.snapshot) {
            self.toggleFooterZindex('');
          }


          $cervedService
            .getCustomer(self.model.riUserG.cf, 'cf', self.model.riUserG.ndg)
            .then(function (cervedResponse) {
              if (cervedResponse.success || !self.customer.metadata.riUserG.ndg) {
                if (cervedResponse && cervedResponse.success && self.customer.metadata.riUserG.ndg) {
                  var checkIfAllDataIsPresent = RiUserG.build(cervedResponse.appCustomerUser.metadata.riUserG).isOk(false, false, false, true);
                  if (!checkIfAllDataIsPresent) {
                    $rootScope.$broadcast("addAlert", {
                      text: "ERROR_CERVED_INCOMPLETE_DATA"
                    });
                    self.onCervedUpdate({
                      showUpdateFromCerved: false
                    });
                    return;
                  }
                }
                if (cervedResponse.success) {
                  cervedResponse.appCustomerUser.metadata.riUserG.telefono = cervedResponse.appCustomerUser.metadata.riUserG.telefono && cervedResponse.appCustomerUser.metadata.riUserG.telefono.replace("/", "")
                  self.riUserG = cervedResponse.appCustomerUser.metadata.riUserG;
                  self.customer.identifier = cervedResponse.appCustomerUser.metadata.riUserG.cf;
                } else {
                  self.riUserG = RiUserG.build();
                  self.riUserG.cf = self.model.riUserG.cf && self.model.riUserG.cf;
                  self.riUserG.piva = self.model.riUserG.piva && self.model.riUserG.piva;
                  self.riUserG.ragioneSocialeProposta = self.model.riUserG.ragioneSocialeProposta;
                }
                if (!self.riUserG.sedeLegale.stato) {
                  self.riUserG.sedeLegale.stato = Stato.build();
                }

                if (self.riUserG.ndg == null && ($giuridicVersion.checkIfInd(self.riUserG.formaGiuridica) || self.riUserG.formaGiuridica === 'PEF') && self.digital) {
                  self.enableNameSurnameRow = true;
                  self.titolare = Titolare.build()
                  self.model.pf = Pf.build(self.titolare);
                  self.model.riUserF = RiUserF.build(self.riUserF);
                  if (self.riUserF && (self.riUserF.listaPf.length === 0)) {
                    self.model.riUserF.listaPf.push(self.model.pf);
                  } else {
                    if (self.riUserF.listaPf[0].nome != null && self.riUserF.listaPf[0].cognome != null) {
                      self.model.populatedPersonaFisica = true;
                    }
                  }
                  self.model.riUserF.listaPf[0] = Pf.build(self.model.riUserF.listaPf[0]);
                  self.model.riUserF.listaPf[0].titolare.selected = true;
                  self.model.riUserF.listaPf[0].cf = cervedResponse.appCustomerUser.metadata.riUserG.cf;
                }

                self.cervedData({
                  dataFromCerved: self.riUserG
                })

                console.log("RiUserG: ", self.riUserG);
                self.onCervedUpdateFinish({
                  value: true
                });
              } else {
                self.onCervedUpdate({
                  showUpdateFromCerved: false
                });

              }




            })
            .catch(function () {
              self.onCervedUpdate({
                showUpdateFromCerved: false
              });
              self.successCervedCall({
                isCervedData: false
              })
            })
            .finally(function () {
              self.toggleFooterZindex('back');
            });

        } else {

          $cervedService
            .getCustomer(self.model.riUserG.piva, 'piva')
            .then(function (cervedResponse) {
              if (cervedResponse) {
                self.riUserG = cervedResponse.appCustomerUser.metadata.riUserG;
                self.customer.identifier = cervedResponse.appCustomerUser.metadata.riUserG.piva;
                if (!self.riUserG.sedeLegale.stato) {
                  self.riUserG.sedeLegale.stato = Stato.build();
                }
                self.cervedData({
                  dataFromCerved: self.riUserG
                })
                self.successCervedCall({
                  isCervedData: true
                })
                console.log("RiUserG: ", self.riUserG);
              }
              self.onCervedUpdate({
                showUpdateFromCerved: false
              });
            })
            .catch(function () {
              self.onCervedUpdate({
                showUpdateFromCerved: false
              });
              self.successCervedCall({
                isCervedData: false
              })
            })
            .finally(function () { });

        }


      };

      self.cervedCallUpdate = function () {

        if (self.digital) {

          if ((self.customer.metadata.riUserG.ndg == null || typeof self.customer.metadata.riUserG.ndg == undefined) && !self.customer.metadata.riUserG.updateFromCerved) {

            self.showBackButton({
              backButton: true
            });

            $timeout(function () {
              self.getUpdatedDataFromCerved();
            }, 200);
            if (!self.snapshot) {
              self.toggleFooterZindex('');
            }


          } else {
            self.showBackButton({
              backButton: false
            });
          }

        } else {

          if (
            !self.customer.ndg &&
            !self.customer.metadata.riUserG.updateFromCerved
          ) {
            self.showBackButton({
              backButton: true
            });
            console.log("cerved update needed!");
            $timeout(function () {
              $modalService.openModal("digitalModalUpdateCerved");
              self.getUpdatedDataFromCerved();
            }, 500);
            console.log("Ho eseguito la modale");
          } else {
            self.showBackButton({
              backButton: false
            });
          }

        }

      };

      self.toggleMoreAddresses = function () {
        self.areMoreAddressesVisible = !self.areMoreAddressesVisible;
      }

      self.toggleFooterZindex = function (par) {

        if (par === 'back') {
          $(".financial-leasing__footer").css("z-index", "1");
        } else {
          $(".financial-leasing__footer").css("z-index", "-1");
        }

      }

      self.getLegalStatusDescription = function (legalStatusCode) {
        if (self.model.dropdown.legalStatuses && legalStatusCode) {
          var result = self.model.dropdown.legalStatuses.find(function (legalStatus) {
            return legalStatus.id == legalStatusCode.toUpperCase()
          });
          return result ? result.id + ' - ' + result.description : '-';
        } else return '-';
      }

      self.getSaeDescription = function (saeCode, saeFromCerved) {
        if (saeFromCerved) {
          if (self.dropdown.saeFromCerved) {
            var result = self.dropdown.saeFromCerved.find(function (sae) {
              return sae.id == saeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
          } else return '-';
        } else {
          if (self.model.dropdown.sae) {
            var result = self.model.dropdown.sae.find(function (sae) {
              return sae.id == saeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
          } else return '-';
        }
      }

      self.getRaeDescription = function (raeCode, raeFromCerved) {
        if (raeFromCerved) {
          if (self.dropdown.raeFromCerved) {
            var result = $scope.dropdown.raeFromCerved.find(function (rae) {
              return rae.id == raeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
          } else return '-';
        } else {
          if (self.model.dropdown.rae) {
            var result = self.model.dropdown.rae.find(function (rae) {
              return rae.id == raeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
          } else return '-';
        }
      }

      var getInfoAlbo = function (formaGiuridica, cdAteco, showAlbo) {
        self.enabledLoader = true;
        $financialApiService
          .getInfoAlbo(formaGiuridica, cdAteco, showAlbo)
          .then(function (response) {
            if (response.success) {
              self.model.riUserG.showAlbo = response.showAlbo;
              self.model.dropdown.alboProfessionale = response.listAlbo;

              if (self.model.dropdown.alboProfessionale && self.model.dropdown.alboProfessionale.length > 0) {
                self.model.dropdown.alboProfessionale.forEach(function (element) {
                  if (element.selected) {
                    self.model.alboSelected = element;
                    return;
                  }
                })
              }
            }
          })
          .catch(function (error) {
            console.log("ERROR:", error);
          })
          .finally(function () {
            self.enabledLoader = false;
          })
      }
    }
  });